import { render, staticRenderFns } from "./SupportInfo.vue?vue&type=template&id=93f1142e&scoped=true&"
import script from "./SupportInfo.vue?vue&type=script&lang=ts&"
export * from "./SupportInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SupportInfo.vue?vue&type=style&index=0&id=93f1142e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f1142e",
  null
  
)

export default component.exports